/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Button, INodeProps} from '@msdyn365-commerce-modules/utilities';
import { ICittaNewsletterSubscribePopUpData } from './citta-newsletter-subscribe-pop-up.data';
import { ICittaNewsletterSubscribePopUpProps } from './citta-newsletter-subscribe-pop-up.props.autogenerated';
import { GetCookie, SetCookie } from '../../shared-utils/cookie-utilities';
export interface ICittaNewsletterSubscribePopUpState {
    cookieValue?: string;
}
export interface ICittaNewsletterSubscribePopUpViewProps extends ICittaNewsletterSubscribePopUpProps<ICittaNewsletterSubscribePopUpData> {
    newsletterSubscribe: React.ReactNode[];
    message: String;
    header: String;
    closeButton?: INodeProps;
    MessageTextProps: INodeProps;
    HeaderTextProps: INodeProps;
    cookieValue: string;
    // state: ICittaNewsletterSubscribePopUpState;
}

/**
 *
 * CittaNewsletterSubscribePopUp component
 * @extends {React.PureComponent<ICittaNewsletterSubscribePopUpProps<ICittaNewsletterSubscribePopUpData>>}
 */
class CittaNewsletterSubscribePopUp extends React.PureComponent<ICittaNewsletterSubscribePopUpProps<ICittaNewsletterSubscribePopUpData>, ICittaNewsletterSubscribePopUpState> {
    private _newsletterCookieName: string = 'cittaSignUp';
    private _timer: any;
    constructor(props: ICittaNewsletterSubscribePopUpViewProps) {
        super(props);
        const cookieValue = GetCookie(props.context.request.cookies, this._newsletterCookieName);

        this.state = {
            cookieValue
        };
    }

    public render(): JSX.Element | null {
        const {
            slots, 
            config,
            context
        } = this.props;
        const isConsentGiven = context && context.request && context.request.cookies && context.request.cookies.isConsentGiven();

        
        if(!this.props.slots || !this.props.slots.newsletterSubscribe || !this.props.slots.newsletterSubscribe.length) {
            this.props.context.telemetry.error('newsletter slots content is empty, module wont render');
            return null;
        }

        if (this.state.cookieValue !== 'HIDE') {
            this.checkCookie();
        }

        if (this.state.cookieValue === 'HIDE' || !isConsentGiven) {
            this.stopTimer();
            return null;
        }

        const viewprops = {
            ...this.props,
            newsletterSubscribe: slots && slots.newsletterSubscribe,
            message: config.message,
            header: config.header || 'keep in touch',
            closeButton: this._renderCloseLink(),
            MessageTextProps: { className: 'ms-message__content' },
            HeaderTextProps: { className: 'ms-header__content' },
            cookieValue: this.state.cookieValue
        }

        return this.props.renderView(viewprops);
    }

    private checkCookie = () => {
        if(!this._timer) {
            this._timer = setInterval(()=> {
                const cookieValue = GetCookie(this.props.context.request.cookies, this._newsletterCookieName);
                if (cookieValue === 'HIDE') {
                    this.setState({cookieValue: 'HIDING'})
                    setTimeout(() => {
                        this.setState({cookieValue: cookieValue })
                    }, 3000)
                }
            }, 1000)
        }
    }

    private stopTimer = () => {
        clearInterval(this._timer);
    }

    private _renderCloseLink = () => {
        return (
            <Button
                className={`close-pop-up__button`}
                color='primary'
                onClick={() => this._setCookie()}
            >x</Button>
        )
    };

    private _setCookie = () => {
        const { config } = this.props;
        this.setState({cookieValue: 'HIDING'})
        SetCookie(this.props.context.request.cookies, 'HIDE', this._newsletterCookieName, config.cookieAge || 2592000)
        setTimeout(() => {
            this.setState({cookieValue: 'HIDE'})
        }, 3000)
    }
}

export default CittaNewsletterSubscribePopUp;
